import { Company } from './company';
import { Location } from './location';

export interface User {
  _id?: string;
  fullname: string;
  email: string;
  // resource?: Location | string;
  role?: string;
  // company: Company | string;
  active: boolean;
  deactivation_date?: Date;
}


export function getEmptyUser() {
  return {
    fullname: "",
    email: "",
    city: "",
    // resource: "",
    company: "",
    role: ""

    // active: ""
  }
}
